import gql from 'graphql-tag';

export const GET_INFRINGEMENTS = gql(`
  query getInfringements(
    $startTime: DateTimeOffset!
    $endTime: DateTimeOffset!
    $first: Int
    $after: String
    $filter: InfringementSummaryFilter
    $sort: [OrderByType]
    $includeOperationTags: Boolean!
) {
    infringementSummariesByTimeRange(
        startTime: $startTime
        endTime: $endTime
        first: $first
        after: $after
        filter: $filter
        sort: $sort
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
        }
        items {
            id
            operationId
            infringementType
            ruleId
            ruleName
            status
            aircraftType
            aircraftCategory
            acid
            time
            airportId
            position {
                altitude
                latitude
                longitude
            }
            severity
            operationType
            detail {
                id
                ... on CorridorInfringement {
                corridorId
                }
                ... on ExclusionInfringement {
                selectionZoneId
                }
                ... on GateInfringement {
                gateId
                gateDirection
                speed
                reason
                }
                ... on NoiseInfringement {
                noiseEventIds
                }
            }
            operationTags(returnOnly: ["Vector"]) @include(if: $includeOperationTags) {
                tagId
                name
                isCompleted
            }
        }
    }
}
`);

export const GET_INFRINGEMENT_CANDIDATES = gql(`
    query getInfringementCandidates(
    $startTime: DateTimeOffset!
    $endTime: DateTimeOffset!
    $first: Int
    $filter: InfringementCandidateSummaryFilter
    $sort: [OrderByType]
) {
    infringementCandidateSummariesByTimeRange(
        startTime: $startTime
        endTime: $endTime
        first: $first
        sort: $sort
        filter: $filter
    ) {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
        }
        items {
            operationId
            infringementType
            ruleId
            ruleName
            status
            aircraftType
            aircraftCategory
            acid
            detail {
                id
                ... on CorridorInfringement {
                    corridorId
                }
                ... on ExclusionInfringement {
                    selectionZoneId
                }
                ... on GateInfringement {
                    gateId
                    gateDirection
                    speed
                    reason
                }
                ... on NoiseInfringement {
                    noiseEventIds
                }
            }
            isInfringement
            time
            airportId
            position {
                altitude
                latitude
                longitude
            }
            severity
            operationType
            infringementId
            rule {
                ... on CorridorInfringementRule {
                    corridorId
                }
            }
        }
    }
}
`);
